import { useTranslation } from "react-i18next";
import { useFormikContext } from "formik";
import { ACTION_STATUS } from "constants/actions";
import { ACTION_VIEW_MODE } from "constants/action-form";
import Title from "../../../Typography/Title";
import SmallText from "../../../Typography/SmallText";
import useAvailableQuantityUnits from "../../utils/useAvailableOperationUnits";
import DateSpan from "../date-span/DateSpan";
import QuantityInput from "../../../action-inputs/quantity/QuantityInput";
import DetailSection from "../DetailSection";
import ActionModalDescriptionSection from "../description/ActionModalDescriptionSection";
import { EquipmentUsed } from "../equipment";
import {
  useDrugFormEffects,
  useFilteredDrugSubstances,
  useSelectedBrandNameActiveSubstances,
  useSuggestedDrugQuantity,
} from "./useDrugFormUtils";
import BioSelectionInput from "components/action-inputs/bio-selection/BioSelectionInput";
import PesticideSelectInput from "components/action-inputs/pesticide/PesticideSelectInput";
import CompositionSelectInput from "components/action-inputs/composition/CompositionSelectInput";
import BrandNameSelectInput from "components/action-inputs/brand-name/BrandNameSelectInput";

const DrugPerformed = ({ viewMode, isFullWidth, isNewVersion }) => {
  const { t } = useTranslation();

  const { values } = useFormikContext();
  const status = ACTION_STATUS.performed;
  const isViewMode = viewMode === ACTION_VIEW_MODE.view;

  const { filteredSubstances } = useFilteredDrugSubstances();
  const { suggestedQuantity } = useSuggestedDrugQuantity(filteredSubstances);
  const { selectedPesticideId } = useDrugFormEffects(
    undefined,
    filteredSubstances,
    isViewMode,
  );
  const { availableQuantityUnits } = useAvailableQuantityUnits(
    values.taskId,
    values.drugAction?.operationTypeId,
  );

  const selectedChemicalActiveSubstances =
    useSelectedBrandNameActiveSubstances();

  return (
    <div className="action-modal-card action-details-box ">
      <div className={isFullWidth && "details-half-width"}>
        <Title title={t("ActionModal.Details.Performed")} />
        {!isNewVersion && <DateSpan viewMode={viewMode} status={status} />}
        <DetailSection
          title={t("ActionModal.ActiveSubstance")}
          isRequired={!isViewMode}
          isNewVersion={isNewVersion}
        >
          <div className={!isViewMode && "action-details-column-multiple"}>
            <BioSelectionInput task="drug" isViewMode={isViewMode} />
            <PesticideSelectInput
              substances={filteredSubstances}
              isViewMode={isViewMode}
            />
            <CompositionSelectInput
              substances={filteredSubstances}
              selectedPesticideId={selectedPesticideId}
              isViewMode={isViewMode}
            />
            <BrandNameSelectInput
              substances={filteredSubstances}
              selectedPesticideId={selectedPesticideId}
              isViewMode={isViewMode}
            />
            <SmallText
              sx={{
                fontStyle: "italic",
                color: "#00000099",
                paddingLeft: "0.5rem",
              }}
            >
              {selectedChemicalActiveSubstances}
            </SmallText>
          </div>
        </DetailSection>
        <DetailSection
          title={t("ActionModal.Quantity")}
          isRequired={!isViewMode}
          isNewVersion={isNewVersion}
        >
          <QuantityInput
            isViewMode={isViewMode}
            task="drug"
            quantityOptions={availableQuantityUnits}
          />
          {!isViewMode && suggestedQuantity && (
            <SmallText
              text={t("ActionModal.SuggestedQuantity", {
                quantity: suggestedQuantity,
              })}
              sx={{
                color: "#818181",
                paddingLeft: "8px",
                marginTop: "4px",
                fontStyle: "italic",
              }}
            />
          )}
        </DetailSection>
        <EquipmentUsed isInEditMode={viewMode !== ACTION_VIEW_MODE.view} />
        <ActionModalDescriptionSection
          task="drug"
          isViewMode={isViewMode}
          isNewVersion={isNewVersion}
        />
      </div>
    </div>
  );
};
export default DrugPerformed;
